import * as React from "react";
import Switch from '@material-ui/core/Switch';
import {
    Edit,
    SelectInput,
    FormWithRedirect,
    TextInput,
    SaveButton,
    DeleteButton,
    Link,
    BooleanInput,
    ImageInput,
    ImageField
} from 'react-admin';
import { Box, Card, CardContent, Typography, Toolbar, Grid, Button, Hidden, InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import api_url from './ApiUrl';
import { CustomBreadcrumb } from './CustomBreadcrumb';
import { List, ListActions } from '@react-admin/ra-enterprise';
import { MarkdownInput } from '@react-admin/ra-markdown';


const useStyles = makeStyles({
    ownfont14: { fontSize: '14px', paddingBottom: '7px' },
    ownfont12: { fontSize: '12px' },
    reactSwitch: { pointerEvents: 'none' },
    paddingTop: { paddingTop: '0px' },
    fweight500: { fontWeight: 500 },
    googleFa: { fontSize: '1rem', fontWeight: 500 }
});

const options = {
    previewStyle: "tab",
    height: "300px",
    initialEditType: "wysiwyg",
    useCommandShortcut: false,
};


const EditMediaForm = (props) => {
    const classes = useStyles();
    const [checked, setChecked] = React.useState(true);
    const handleChange = (event) => {
        setChecked(event.target.checked);
    }

    return (
        <FormWithRedirect {...props} render={formProps => (
            <div>
                <CardContent>
                    <Grid container>
                        <Grid item xs={8}>
                            <Box flex={1} mr="1em" style={{ borderRight: '1px dashed #ccc' }}>
                                <Grid container className="topinputfield">
                                    <Grid item xs={12}>
                                        <Box mr="1em">
                                            <TextInput source="titles" variant="outlined" resource="news" label="Post Title" fullWidth className="customInputHeight" />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Box mr="1em" className="newmarkdown">
                                            <MarkdownInput variant="outlined" source="details" resource="news" options={options} label="Content" fullWidth />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} className="newmarkdown">
                                        <Box mr="1em">
                                            <ImageInput source="pictures" label="Cover">
                                                <ImageField source="photo" title="Cover photo" />
                                            </ImageInput>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>

                        <Grid item xs={4} className="topinputfield">
                            <Grid item xs={12}>
                                <Grid container>
                                    <Grid item sm={10}>
                                        <Box pt={2}>
                                            <InputLabel className={classes.fontWeightSize}>Publish</InputLabel>
                                        </Box>
                                    </Grid>
                                    <Grid item sm={2}>
                                        <Box pt={1} style={{ float: 'right' }}>
                                            {/* <Switch
                                                checked={checked}
                                                onClick={handleChange}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            /> */}
                                            <BooleanInput label="" source="status" />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Box mr="1em">
                                    <TextInput source="meta_title" variant="outlined" resource="news" label="Meta title" fullWidth className="customInputHeight" />
                                </Box>
                            </Grid>

                            <Grid item xs={12}>
                                <Box mr="1em">
                                    <TextInput multiline source="meta_description" variant="outlined" resource="news" label="Meta description" fullWidth className="customInputHeight" />
                                </Box>
                            </Grid>

                            <Grid item xs={12}>
                                <Box mr="1em">
                                    <TextInput source="meta_keyword" variant="outlined" resource="news" label="Meta keywords" fullWidth className="customInputHeight" />
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box flex={1} mr="1em" mt="1em">
                                    <SaveButton
                                        saving={formProps.saving}
                                        handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                                    />
                                    <Link to={'/news?filter={"type":"news"}'}><Button variant="outlined" color="default" style={{ marginLeft: '15px' }}>
                                        Cancel
                                    </Button></Link>
                                </Box>
                            </Grid>

                        </Grid>
                    </Grid>
                </CardContent>
            </div>
        )}
        />
    )
};
const MediaEditActions = (props) => (
    <ListActions  {...props} breadcrumb={<CustomBreadcrumb variant="actions" />} exporter={false} />
)
const EditMedia = (props) => {
    return (
        <Edit {...props} actions={<MediaEditActions />}>
            <EditMediaForm />
        </Edit>
    )
};
export default EditMedia;